// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Incoming = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Incoming-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <g stroke="currentColor" clipPath={`url(#${instanceId}-Incoming_a)`}>
        <path d="M11.813 10.688h4.5v-4.5" />
        <path strokeLinejoin="round" d="M2.25 12.938a6.75 6.75 0 0 1 11.523-4.773l2.54 2.523" />
      </g>
      <defs>
        <clipPath id={`${instanceId}-Incoming_a`}>
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(Incoming);
export default ForwardRef;
